import axios from 'axios';

// Cliente HTTP dedicado para /empresa. No toca utils/api.js.
const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

const client = axios.create({
  baseURL: `${API_BASE}/api`,
  timeout: 10000,
});

// Inyectar token si existe (mismo patrón que utils/api.js)
client.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
  } catch (_) { /* ignore */ }
  return config;
});

export const empresaAPI = {
  /**
   * Devuelve la configuración de la empresa: {skin_activo, actualizado_en}.
   * No requiere autenticación (público) para permitir aplicar el skin
   * en la pantalla de Login antes de que exista sesión.
   */
  getConfig: () => client.get('/empresa/config'),

  /**
   * Actualiza la configuración de la empresa. Requiere permiso
   * editar /empresa (definido en el módulo Roles).
   */
  updateConfig: (payload) => client.put('/empresa/config', payload),
};

export default empresaAPI;
